import GMRaport from "../components/gm-raport";
import SiteMenu from "../components/menu";

export default function GameMastersPage() {
    return <>
        <SiteMenu />
        <GMRaport />
    </>
}
